export default theme => ({
  input: {
    margin: 0
  }
});
